<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
const default_layout = "index";

export default {
  data() {
    return {
      isExpired: false
    }
  },
  computed: {
    layout() {
      // return "merchant-layout";
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
  methods: {
    checkSessionExpired() {
      if (this.isExpired) {
        this.$router.push("login");
      }
    }
  }
};
</script>

